import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Card } from "../common/Card";
import { PieChartShimmer } from "../../common/reportDashBShimmer/PieChartShimmer";
import { WalletSectionError } from "./WalletSectionError";

export function WalletActivitySection({ state, activityData }) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <span className="mb-6 text-[#1A1A1A] text-lg">
        Wallet Activity & Balance Growth
      </span>
      {state.loading ? (
        <PieChartShimmer />
      ) : state.error ? (
        <WalletSectionError message={state.message} onRetry={state.onRetry} />
      ) : activityData.length > 0 ? (
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={activityData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="month" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="creditsAdded"
              stroke="#10B981"
              strokeWidth={2}
              name="Credits Added ($)"
            />
            <Line
              type="monotone"
              dataKey="creditsSpent"
              stroke="#EF4444"
              strokeWidth={2}
              name="Credits Spent ($)"
            />
            <Line
              type="monotone"
              dataKey="totalBalance"
              stroke="#1E61DC"
              strokeWidth={3}
              name="Total Balance ($)"
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[350px] flex items-center justify-center text-gray-400">
          No wallet activity data available
        </div>
      )}
    </Card>
  );
}
